/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import CommunicationService from "Lib/API/Communication/index";
import { DateFormetContext } from "app/App.js";
import InfoTooltip from "components/InfoTooltip";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import Button from "components/button/Button";
import AudienceParticipantsTable from "./AudienceParticipantsTable";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as _ from "lodash";
import moment from "moment";
import "pages/Members/MemberTables/memberTablse.scss";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router";
import { useReactToPrint } from "react-to-print";
import { formatPhoneNumber } from "utils/phoneNumberFormat.js";
import Filter from "./filter";
import { filterOrder, getFilterData } from "./filterSlice";

const hasContactValue = (value) =>
  typeof value === "string" ? value.trim().length > 0 : Boolean(value);

const getParticipantFamilyName = (participant) => {
  const name =
    participant?.family_name ||
    participant?.account?.family_name ||
    participant?.account?.name ||
    "";
  return typeof name === "string" ? name.trim() : "";
};

const SearchResult = ({
  goToParameter,
  id,
  formik,
  closeModal,
  setRefresh,
}) => {
  const dateFormet = React.useContext(DateFormetContext);
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [columnsDownload, setColumnsDownload] = React.useState([]);
  const [datasDownload, setDatasDownload] = React.useState([]);
  const state = useSelector((state) => state.filterParams.filterTable);
  const fieldsOrder = useSelector((state) => state.filterParams.fieldsOrder);
  const queryParams = new URLSearchParams(window.location.search);
  const [filterDisplay, setFilterDisplay] = React.useState([]);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [isSaveLoading, setIsSaveLoading] = useState(false);
  const [participantAccountFilter, setParticipantAccountFilter] = useState("");
  const selectedFieldorders = useSelector(
    (state) => state.filterParams.fieldsOrder
  );
  const { fieldsGroup } = useSelector((state) => state?.filterParams);

  useEffect(() => {
    if (filterDisplay?.length > 0 && !fieldsOrder) {
      dispatch(filterOrder(filterDisplay));
    }
  }, [filterDisplay]);

  const getOrderKeys = selectedFieldorders?.map((order) => {
    let key;
    Object.keys(
      typeof datasDownload[0] === "object" && datasDownload[0]
    )?.forEach((keyy) => {
      if (keyy === order?.fieldName) {
        key = keyy;
      }
      if (order?.displayName === "Active Address") {
        key = "account.addresses.active_address";
      }
      if (order?.displayName === "Active City") {
        key = "account.addresses.active_city";
      }
      if (order?.displayName === "Active Address Line 2") {
        key = "account.addresses.active_addressLine2";
      }

      if (order?.displayName === "Active State") {
        key = "account.addresses.active_state";
      }
      if (order?.displayName === "Active Zip code") {
        key = "account.addresses.active_zip_code";
      }
      if (order?.displayName === "Active Neighborhood") {
        key = "account.addresses.active_neighborhood";
      }
      if (order?.displayName === "Active Country") {
        key = "account.addresses.active_country";
      }
      if (order?.displayName === "Billing Address") {
        key = "account.addresses.billing_address";
      }
      if (order?.displayName === "Billing Address Line 2") {
        key = "account.addresses.billing_addressLine2";
      }
      if (order?.displayName === "Billing City") {
        key = "account.addresses.billing_city";
      }
      if (order?.displayName === "Billing State") {
        key = "account.addresses.billing_state";
      }
      if (order?.displayName === "Billing Zip code") {
        key = "account.addresses.billing_zip_code";
      }
      if (order?.displayName === "Billing Neighborhood") {
        key = "account.addresses.billing_neighborhood";
      }
      if (order?.displayName === "Billing Country") {
        key = "account.addresses.billing_country";
      }
      if (order?.displayName === "Address") {
        key = "location.formattedAddress";
      }
    });
    return key;
  });

  const orderDatasDownload = datasDownload.map((item) => {
    let obj = {};
    getOrderKeys.forEach((ele) => {
      if (ele in item) {
        obj[ele] = item[ele];
      }
    });
    return obj;
  });

  let newFieldsOrderObjects =
    fieldsOrder?.filter((el) => typeof el === "object" && el !== null) || [];
  let newFieldsOrder =
    newFieldsOrderObjects?.length !== 0
      ? [
          ...newFieldsOrderObjects,
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing Zip code") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing Zip Code",
            fieldName: "account.addresses.billing_zip_code",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active Zip code") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active Zip code",
            fieldName: "account.addresses.active_zip_code",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active City") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active City",
            fieldName: "account.addresses.active_city",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active City") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active City",
            fieldName: "account.addresses.active_city",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active Address Line 2") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active Address Line 2",
            fieldName: "account.addresses.active_addressLine2",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing Address Line 2") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing Address Line 2",
            fieldName: "account.addresses.billing_addressLine2",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing City") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing City",
            fieldName: "account.addresses.billing_city",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing State") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing State",
            fieldName: "account.addresses.billing_state",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active State") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active State",
            fieldName: "account.addresses.active_state",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing Address") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing Address",
            fieldName: "account.addresses.billing_address",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active Address") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Acvive Address",
            fieldName: "account.addresses.active_address",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Active Neighborhood") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active Neighborhood",
            fieldName: "account.addresses.active_neighborhood",
          },
          newFieldsOrderObjects?.find((item) => {
            if (item?.displayName == "Billing Neighborhood") {
              return true;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing Neighborhood",
            fieldName: "account.addresses.billing_neighborhood",
          },
          newFieldsOrderObjects?.find((o, i) => {
            if (o?.displayName == "Billing Country") {
              return o;
            }
          }) && {
            collectionName: "Account",
            displayName: "Billing Country",
            fieldName: "account.addresses.billing_country",
          },
          newFieldsOrderObjects?.find((o, i) => {
            if (o?.displayName == "Active Country") {
              return o;
            }
          }) && {
            collectionName: "Account",
            displayName: "Active Country",
            fieldName: "account.addresses.active_country",
          },
        ]
      : [];

  const columns = [
    {
      field: "profile_img",
      headerName: "Profile Picture",
      width: 220,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col">
            <div className="user-icon d-flex flex-row">
              <img
                src={
                  data?.row?.profile_img || "https://via.placeholder.com/150"
                }
                style={{ height: "50px", borderRadius: "3px", width: "50px" }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: 220,
      headerClassName: "report-table-name-cell",
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col h-100">
            <div className="name-container d-flex align-items-center flex-column">
              {data?.row?.first_name && (
                <>
                  <p
                    className="id-container m-0 p-0"
                    style={{
                      width: "200px",
                      color: "grey",
                      fontWeight: "100",
                      fontSize: "13px",
                    }}
                  >
                    {data?.row?.first_name}
                  </p>
                </>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "hebrew_name",
      headerName: "Hebrew Name",
      width: 220,
      headerClassName: "report-table-name-cell",
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col h-100">
            <div className="name-container d-flex align-items-center flex-column">
              {data?.row?.hebrew_name && (
                <>
                  <p
                    className="id-container m-0 p-0"
                    style={{
                      width: "200px",
                      color: "grey",
                      fontWeight: "100",
                      fontSize: "13px",
                    }}
                  >
                    {data?.row?.hebrew_name}
                  </p>
                </>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "middle_name",
      headerName: "Middle Name",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.middle_name ? data?.row?.middle_name : "-"}
          </div>
        );
      },
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.last_name ? data?.row?.last_name : "-"}
          </div>
        );
      },
    },
    {
      field: "date_of_birth",
      headerName: "DOB",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.date_of_birth
              ? moment(data?.row?.date_of_birth)
                  .utcOffset("+0100")
                  .format(dateFormet)
              : "-"}
          </div>
        );
      },
    },
    {
      field: "age",
      headerName: "age",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.age}</div>;
      },
    },
    {
      field: "ageYear",
      headerName: "ageYear",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageYear}</div>;
      },
    },
    {
      field: "ageDay",
      headerName: "ageDay",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageDay}</div>;
      },
    },
    {
      field: "ageMonth",
      headerName: "ageMonth",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageMonth}</div>;
      },
    },
    {
      field: "nickname",
      headerName: "nickname",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.nickname}</div>;
      },
    },
    {
      field: "addressLine2",
      headerName: "addressLine2",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.addressLine2}</div>;
      },
    },
    {
      field: "next_birthday",
      headerName: "Next Birthday",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.date_of_birth
              ? moment(data?.row?.date_of_birth)
                  .utcOffset("+0100")
                  .format(dateFormet)
              : "-"}
          </div>
        );
      },
    },
    {
      field: "next_anniversary",
      headerName: "Next Anniversary",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.date_of_birth
              ? moment(data?.row?.date_of_birth)
                  .utcOffset("+0100")
                  .format(dateFormet)
              : "-"}
          </div>
        );
      },
    },
    {
      field: "account.join_date",
      headerName: "JOIN NAME",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.join_date
            ? moment(data?.row?.account?.join_date)
                .utcOffset("+0100")
                .format(dateFormet)
            : "-"}
        </div>
      ),
    },
    {
      field: "account.numberOfFamilyMembers",
      headerName: "NUMBER OF FAMILY MEMBER",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.account?.numberOfFamilyMembers}
          </div>
        );
      },
    },
    {
      field: "relationship",
      headerName: "Relationship",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.relationship || "-"}</div>
      ),
    },
    {
      field: "zip_code",
      headerName: "Zip Code",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.zip_code || "-"}</div>
      ),
    },
    {
      field: "city",
      headerName: "City",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.city || "-"}</div>
      ),
    },
    {
      field: "religion",
      headerName: "Religion",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.religion || "-"}</div>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.title || "-"}</div>
      ),
    },
    {
      field: "gender",
      headerName: "Sex",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.gender || "-"}</div>
      ),
    },
    {
      field: "email_address",
      headerName: "EMAIL",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.email_address || "-"}</div>
      ),
    },
    {
      field: "mobile_number",
      headerName: "Mobile Number",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.mobile_number || "-"}</div>
      ),
    },
    {
      field: "home_phone",
      headerName: "HOME PHONE",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.home_phone || "-"}</div>
      ),
    },
    {
      field: "pronounce",
      headerName: "Pronounce",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.pronounce || "-"}</div>
      ),
    },
    {
      field: "social_status",
      headerName: "Status",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.social_status || "-"}</div>
      ),
    },
    {
      field: "emergency_contact_number",
      headerName: "Emergency Contact Number",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.emergency_contact_number || "-"}
        </div>
      ),
    },
    {
      field: "occupation",
      headerName: "OCCUPATION",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.occupation || "-"}</div>
      ),
    },
    {
      field: "anniversary_date",
      headerName: "Anniversary",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.anniversary_date
            ? moment(data?.row?.anniversary_date)
                .utcOffset("+0100")
                // .utcOffset("+0100")
                .format(dateFormet)
            : "-"}
        </div>
      ),
    },
    {
      field: "metva_date",
      headerName: "Bar/Bat Mitzvah",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.metva_date
            ? moment(data?.row?.metva_date)
                .utcOffset("+0100")
                // .utcOffset("+0100")
                .format(dateFormet)
            : "-"}
        </div>
      ),
    },
    {
      field: "address",
      headerName: "ADDRESS",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.address || "-"}</div>
      ),
    },
    {
      field: "account.family_name",
      headerName: "FAMILY NAME",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.family_name || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.billing_type.title",
      headerName: "BILLING TYPE",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.payment?.billing_type?.title || "-"}
        </div>
      ),
    },
    {
      field: "account.admin_contact",
      headerName: "ADMIN CONTACT",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.admin_contact || "-"}
        </div>
      ),
    },
    {
      field: "account.admin_name",
      headerName: "ADMIN NAME",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.family_name || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.account_type",
      headerName: "ACCOUNT TYPE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.payment?.account_type || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_zip_code",
      headerName: "BILLING ZIP CODE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.zip_code;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_zip_code",
      headerName: "ACTIVE ZIP CODE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.zip_code;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_city",
      headerName: "BILLING CITY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_city",
      headerName: "ACTIVE CITY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_addressLine2",
      headerName: "ACTIVE ADDRESS LINE 2",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.addressLine2;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_addressLine2",
      headerName: "BILLING ADDRESS LINE 2",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.addressLine2;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "location.formattedAddress",
      headerName: "LOCATION ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.location.formattedAddress ?? "-"}
        </div>
      ),
    },

    {
      field: "account.addresses.active_neighborhood",
      headerName: "ACTIVE NEIGHBORHOOD",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.neighborhood;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_neighborhood",
      headerName: "BILLING NEIGHBORHOOD",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.neighborhood;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_country",
      headerName: "ACTIVE COUNTRY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.country;
            }
          }) || "-"}
        </div>
      ),
    },

    {
      field: "account.addresses.billing_country",
      headerName: "BILLING COUNTRY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.country;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_address",
      headerName: "ACTIVE ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.location?.formattedAddress?.split(",")[0];
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_address",
      headerName: "BILLING ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.location?.formattedAddress?.split(",")[0];
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_state",
      headerName: "BILLING STATE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_state",
      headerName: "ACTIVE STATE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.account_id",
      headerName: "ACCOUNT ID",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.account_id || "-"}
        </div>
      ),
    },
    {
      field: "account.old_account_id",
      headerName: "OLD ACCOUNT ID",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.old_account_id || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.account_sub_type.title",
      headerName: "CATEGORY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.account_sub_type?.title || "-"}
        </div>
      ),
    },
    {
      field: "tags",
      headerName: "CONTACT TAGS",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.tags || "-"}</div>
      ),
    },
    {
      field: "account.tags",
      headerName: "ACCOUNT TAGS",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.tags || "-"}</div>
      ),
    },

    {
      field: "account.resign_date",
      headerName: "RESIGN DATE",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.resign_date || "-"}
        </div>
      ),
    },
  ];

  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    setLoading(true);
    const data =
      state?.length &&
      state?.map((item) => {
        return {
          ...item,
          ...item?.payment,
          id: item?._id,
          ...(item?.account?.family_name && {
            ["account.family_name"]: item?.account?.family_name,
          }),
          ...(item?.location?.formattedAddress && {
            ["location.formattedAddress"]: item?.location?.formattedAddress,
          }),
          ...(item?.account?.join_date && {
            ["account.join_date"]: item?.account?.join_date,
          }),
          ...(item?.account?.numberOfFamilyMembers && {
            ["account.numberOfFamilyMembers"]:
              item?.account?.numberOfFamilyMembers,
          }),
          ...(item?.account?.admin_name && {
            ["account.admin_name"]: item?.account?.admin_name,
          }),
          ...(item?.account?.admin_contact && {
            ["account.admin_contact"]: item?.account?.admin_contact,
          }),
          ...(item?.account?.country && {
            ["account.addresses.country"]: item.account?.addresses?.map(
              (item) => {
                return item?.country;
              }
            )[0],
          }),
          ...(item?.account?.tags && {
            ["account.tags"]: item?.account?.tags?.map((item) => {
              return item;
            }),
          }),
          ...(item?.tags && {
            ["tags"]: item?.tags?.map((item) => {
              return item;
            }),
          }),
          ...(item?.account?.payment?.account_type && {
            ["account.payment.account_type"]:
              item?.account?.payment?.account_type,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.zip_code && {
            ["account.addresses.billing_zip_code"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.zip_code,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.zip_code && {
            ["account.addresses.active_zip_code"]:
              item?.account?.addresses?.find((item) => {
                if (item?.active == true) {
                  return item;
                }
              })?.zip_code,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.city && {
            ["account.addresses.billing_city"]: item?.account?.addresses?.find(
              (o, i) => {
                if (o.billing === true) {
                  return o;
                }
              }
            )?.city,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.city && {
            ["account.addresses.active_city"]: item?.account?.addresses?.find(
              (item) => {
                if (item?.active == true) {
                  return item?.city;
                }
              }
            )?.city,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.addressLine2 && {
            ["account.addresses.active_addressLine2"]:
              item?.account?.addresses?.find((item) => {
                if (item?.active == true) {
                  return item?.addressLine2;
                }
              })?.addressLine2,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.addressLine2 && {
            ["account.addresses.billing_addressLine2"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.addressLine2,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.state && {
            ["account.addresses.active_state"]: item?.account?.addresses?.find(
              (item) => {
                if (item?.active == true) {
                  return item;
                }
              }
            )?.state,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.state && {
            ["account.addresses.billing_state"]: item?.account?.addresses?.find(
              (o, i) => {
                if (o.billing === true) {
                  return o;
                }
              }
            )?.state,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.country && {
            ["account.addresses.billing_country"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.country,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.active === true) {
              return o;
            }
          })?.country && {
            ["account.addresses.active_country"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })?.country,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.active === true) {
              return o;
            }
          })?.neighborhood && {
            ["account.addresses.active_neighborhood"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })?.neighborhood,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.neighborhood && {
            ["account.addresses.billing_neighborhood"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.neighborhood,
          }),
          ...(item?.account?.addresses
            ?.find((o, i) => {
              if (o.active === true) {
                return o;
              }
            })
            ?.location?.formattedAddress?.split(",")[0] && {
            ["account.addresses.active_address"]: item?.account?.addresses
              ?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })
              ?.location?.formattedAddress?.split(",")[0],
          }),
          ...(item?.account?.addresses
            ?.find((o, i) => {
              if (o.billing === true) {
                return o;
              }
            })
            ?.location?.formattedAddress?.split(",")[0] && {
            ["account.addresses.billing_address"]: item?.account?.addresses
              ?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })
              ?.location?.formattedAddress?.split(",")[0],
          }),
          ...(item?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.neighborhood;
            }
          })[0] && {
            ["account.addresses.active_neighborhood"]:
              item?.account?.addresses?.map((item) => {
                if (item?.active == true) {
                  return item?.neighborhood;
                }
              })[0],
          }),
          ...(item?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.neighborhood;
            }
          })[0] && {
            ["account.addresses.billing_neighborhood"]:
              item?.account?.addresses?.map((item) => {
                if (item?.billing == true) {
                  return item?.neighborhood;
                }
              })[0],
          }),
          // ...(item?.account?.addresses?.map((item) => {
          //   if (item?.billing == true) {
          //     return item?.location?.formattedAddress;
          //   }
          // })[0] && {
          //   ["account.addresses.active_address"]: item?.addresses
          //     ?.map((item) => {
          //       if (item?.active == true) {
          //         return item?.location?.formattedAddress?.replace(/,/g, "");
          //       }
          //     })[0]
          //     ?.replace(/,/g, ""),
          // }),
          // ...(item?.account?.addresses?.map((item) => {
          //   if (item?.billing == true) {
          //     return item?.location?.formattedAddress;
          //   }
          // })[0] && {
          //   ["account.addresses.billing_address"]: item?.addresses
          //     ?.map((item) => {
          //       if (item?.billing == true) {
          //         return item?.location?.formattedAddress?.replace(/,/g, "");
          //       }
          //     })[0]
          //     ?.replace(/,/g, ""),
          // }),
          ...(item?.account?.old_account_id && {
            ["account.old_account_id"]: item?.account?.old_account_id,
          }),
          ...(item?.account?.account_id && {
            ["account.account_id"]: item?.account?.account_id,
          }),
          ...(item?.account?.payment?.account_sub_type?.title && {
            ["account.payment.account_sub_type.title"]:
              item?.account?.payment?.account_sub_type?.title,
          }),
          ...(item?.account?.payment?.billing_type?.title && {
            ["account.payment.billing_type.title"]:
              item?.account?.payment?.billing_type?.title,
          }),
          ...(item?.account?.join_date && {
            ["account.join_date"]: moment(item?.account?.join_date)
              .utcOffset("+0100")
              .format(dateFormet),
          }),
          ...(item?.account?.numberOfFamilyMembers && {
            ["account.numberOfFamilyMembers"]:
              item?.account?.numberOfFamilyMembers,
          }),
          ...(item?.account?.resign_date && {
            ["account.resign_date"]: moment(item?.account?.resign_date)
              .utcOffset("+0100")
              .format(dateFormet),
          }),
        };
      });
    setTimeout(() => {
      setLoading(false);
    }, 2100);

    setTimeout(() => {
      setList(data || []);
    }, 2000);

    if (data?.length) {
      const runReportFieldNames = list
        ?.map((item) => {
          return Object.keys(item);
        })[0]
        ?.map((p) => {
          return {
            collectionName: "Members",
            fieldName: p,
            displayName: "Phone",
          };
        });
      const ColumnsDownlod = columns?.map((columnData) => {
        const dataForColumn = data?.map((rowData) => {
          if (rowData[columnData?.field]) {
            return rowData[columnData?.field];
          } else if (rowData[columnData?.field]) {
            return rowData[columnData?.field];
          }
        });
        const foundFromParams = _.find(
          newFieldsOrder,
          (item) => item?.fieldName === columnData?.field
        );
        if (foundFromParams) {
          return {
            id: columnData?.field,
            displayName: columnData?.headerName,
            dataForColumn,
          };
        }
      });
      let newArray = [];
      const ColumnsDownlodFilter = _.filter(ColumnsDownlod, (item) => item);
      const RowDownlod = ColumnsDownlodFilter?.map((download, index) => {
        const updatedData = download?.dataForColumn?.map((dataForColumn) => {
          const foundFromParams = _.find(
            newFieldsOrder,
            (item) => item?.fieldName === download.id
          );
          if (foundFromParams) {
            let updatedDataForColumn = dataForColumn;
            if (
              (download.id === "home_phone" ||
                download.id === "mobile_number") &&
              dataForColumn
            ) {
              updatedDataForColumn = formatPhoneNumber(dataForColumn);
            }
            if (download.id === "date_of_birth" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "next_birthday" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                // .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "next_anniversary" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                // .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "anniversary_date" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "metva_date" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "account.join_date" && dataForColumn) {
              updatedDataForColumn = moment(dataForColumn)
                .utcOffset("+0100")
                .utcOffset("+0100")
                .format(dateFormet);
            }
            if (download.id === "location.formattedAddress" && dataForColumn) {
              updatedDataForColumn = dataForColumn;
            }
            return {
              [download.id]: updatedDataForColumn,
            };
          }
        });
        if (newArray?.length) {
          newArray = newArray.map((array, index2) => {
            return {
              ...array,
              ...updatedData[index2],
            };
          });
        } else {
          newArray = updatedData;
        }
        setDatasDownload(newArray);
      });
      setColumnsDownload(ColumnsDownlodFilter);
    }
  }, [state, id]);

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      if (id) {
        AuthService.getFilterById(id, token)
          .then((res) => {
            setFilterDisplay(res?.selectedFieldsOrder);
          })
          .catch((err) => toastr.error("Error", err?.data?.message));
      }
    }
    fetchMyAPI();
  }, [id, getAccessTokenSilently]);

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  //for print
  const componentRef = useRef();
  const tableDownlaodRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  let whichPage = localStorage.getItem("goToCommunication");
  React.useEffect(() => {
    const getById = async () => {
      const token = await getAccessTokenSilently();
      dispatch(getFilterData({ id, token: token }));
    };
    if (whichPage == "results") {
      getById();
    }
  }, [id]);
  const handleSave = async () => {
    setIsSaveLoading(true);
    const token = await getAccessTokenSilently();
    // if (filterName) {
    const data_to_send = {
      name: formik.values?.name,
      description: formik.values?.note,
      filter: {
        selectedFields: Object.keys(fieldsGroup)?.map((key) => {
          const mainArray = fieldsGroup?.[key]?.values ?? [];
          const lineIndex = 0;
          const lineContainsArray = Array.isArray(mainArray[lineIndex]);
          return {
            collectionName: fieldsGroup[key]?.collectionName || "",
            fieldName: key,
            type: fieldsGroup[key].oprInputType,
            displayName: fieldsGroup[key].displayName,
            operator: fieldsGroup[key].operator,
            fieldValue: lineContainsArray
              ? fieldsGroup[key].values?.[0]
              : fieldsGroup[key].values || [],
          };
        }),
      },
    };

    const data_to_edit = {
      id: id,
      name: formik.values?.name,
      description: formik.values?.note,
      filter: {
        selectedFields: Object.keys(fieldsGroup)?.map((key) => {
          const mainArray = fieldsGroup?.[key]?.values ?? [];
          const lineIndex = 0;
          const lineContainsArray = Array.isArray(mainArray[lineIndex]);
          return {
            collectionName: fieldsGroup[key]?.collectionName || "",
            fieldName: key,
            operator: fieldsGroup[key].operator,
            type: fieldsGroup[key].oprInputType,
            displayName: fieldsGroup[key].displayName,
            fieldValue: lineContainsArray
              ? fieldsGroup[key].values?.[0] : fieldsGroup[key]?.oprInputType === "multiSelect" ? fieldsGroup[key].values?.split(" , ") 
              : fieldsGroup[key].values || [],
          };
        }),
      },
    };
    if (id) {
      await CommunicationService.editFilter(data_to_edit, token)
        .then((res) => {
          setIsSaveLoading(false);
          closeModal();
          toastr.success("Success", "Audience Edited Successfully!");
          setRefresh(true);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    } else {
      await CommunicationService.sendFilterParams(data_to_send, token)
        .then((res) => {
          setIsSaveLoading(false);
          closeModal();
          toastr.success("Success", "Audience Saved Successfully!");
          setRefresh(true);
        })
        .catch((err) => {
          toastr.error("Error", err?.data?.message);
        });
    }

    setOpen(false);
  };

  const participantAccountFilterValue = participantAccountFilter.trim().toLowerCase();
  const filteredParticipants = (state || []).filter((participant) => {
    if (!participantAccountFilterValue) return true;
    const accountName = getParticipantFamilyName(participant).toLowerCase();
    return accountName.includes(participantAccountFilterValue);
  });

  return (
    <>
      <hr />
      <div className="results-border">
        <div className="info_box_audience">
          <div className="audience-summary-section">
            <span className="audience-summary-communications-title" style={{ display: "flex", alignItems: "center" }}>
              Summary
              <InfoTooltip text="Shows how many people currently match your filter, updated live as you add or change conditions. Saving makes this audience available to pick when creating a Campaign or Automation." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
            </span>
          </div>
          <AudienceParticipantsTable
            participants={filteredParticipants}
            searchValue={participantAccountFilter}
            onSearchChange={(event) =>
              setParticipantAccountFilter(event.target.value)
            }
            hasContactValue={hasContactValue}
            getParticipantFamilyName={getParticipantFamilyName}
            audienceName={formik?.values?.name}
            audienceCount={state?.length}
          />
        </div>
      </div>
      <MyModal
        open={openFilter}
        onClose={handleCloseFilter}
        className="filter-card"
      >
        <Filter from="resultFilter" />
      </MyModal>

      <div className="audience-results-footer">
        <hr />
        <div className="buttons-inside-audience-info">
          <Button
            style={{
              display: location?.state?.value ? "none" : "",
            }}
            onClick={goToParameter}
            disabled={whichPage == "results" ? true : false}
            variant="primary-outline"
            size="md"
          >
            <span>Previous</span>
          </Button>
          <Button
            style={{
              display: location?.state?.value ? "none" : "",
              border: "none",
              width: "fit-content",
            }}
            onClick={() => handleSave()}
            disabled={isSaveLoading}
            variant="primary"
            size="md"
          >
            <span>Save</span>
          </Button>
        </div>
      </div>
    </>
  );
};

export default SearchResult;
